import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services/updateData';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
export const EditUploadForm = ({ upload, setFiles, onClose }) => {
    const [formData, setFormData] = useState({
        upload_name: upload?.upload_name || ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const { token, base_url } = useAppContext();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isLoading) return; // Prevent multiple submissions
        
        if (!formData.upload_name.trim()) {
            window.showAlert(400, 'Upload name is required');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            const response = await updateData(token, `${base_url}/apis/uploads/${upload.id}`, {
                upload_name: formData.upload_name.trim()
            });

            if (response && response.upload) {
                setFiles(prevFiles => prevFiles.map(f => f.id === upload.id ? response.upload : f));
                window.showAlert(200, 'Upload updated successfully!');
                onClose();
            } else {
                window.showAlert(500, 'Failed to update upload: ' + (response?.msg || 'Unknown error'));
            }
        } catch (err) {
            setError('Failed to update upload. Please try again.');
            window.showAlert(500, 'Failed to update upload. Please try again.');
            console.error('Update upload error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return createPortal(
        <div className="modal-overlay">
            <div className="modal-content">
                <button 
                    className="modal-close-button"
                    onClick={onClose}
                >
                    ×
                </button>
                
                <h2 className="modal-title">Edit Upload</h2>
                
                {error && (
                    <div className="form-error-banner">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="upload_name" className="form-label">
                            Upload Name *
                        </label>
                        <input
                            type="text"
                            id="upload_name"
                            name="upload_name"
                            className="form-input"
                            value={formData.upload_name}
                            onChange={handleInputChange}
                            placeholder="Enter upload name"
                            autoFocus
                        />
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isLoading || !formData.upload_name.trim()}
                        >
                            {isLoading ? (
                                <>
                                    <FontAwesomeIcon icon={faSpinner} spin /> Updating...
                                </>
                            ) : (
                                'Update Upload'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>,
        document.body
    );
};
